module.exports = __webpack_public_path__ + "static/media/54.bb7ba464.png";